import EmailSettings from './views/EmailSettings.vue'

export default [
  {
    path: '/settings/emails',
    component: EmailSettings,
    menu: {
      section: 'Configuración',
      icon: 'email',
      title: 'Correos',
      scope: ['admin', 'cliente']
    },
    name: 'emailSettings',
    meta: {
      isAuthenticated: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/settings/routes.js